import React from 'react';
import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export type SourceType = 'built-in' | 'added';

export interface SourceCellProps {
  source: SourceType;
  showTooltip?: boolean;
}

export const SourceCell: React.FC<SourceCellProps> = ({
  source,
  showTooltip = true,
}) => {
  const config = {
    'built-in': {
      label: 'Built-in',
      tooltip:
        'Included with the IDE/Platform installation (not installed by users or policy)',
      variant: 'outline' as const,
    },
    added: {
      label: 'Added',
      tooltip:
        'Not included with the IDE/Platform by default; installed later by a user or via policy',
      variant: 'outline' as const,
    },
  };

  const { label, tooltip, variant } = config[source];

  if (!showTooltip) {
    return (
      <Badge variant={variant} className="cursor-default">
        {label}
      </Badge>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant={variant} className="cursor-help">
            {label}
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
